module.exports = __webpack_public_path__ + "img/tree-02-c-trunk.47a32195.png";